import React, { useEffect, useState } from 'react';
import {Controller, useFormContext } from 'react-hook-form';
import { TextField, Grid, Box, Chip, FormControl, Select, MenuItem, Typography, Card, Checkbox, ListItemText, Autocomplete } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { CalendarIcon, DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { BookingService } from '../../Booking/Service';
import { pattern } from '../../../components/Pattern/Pattern';
import ImageSection from './ImageSection';
import { UrbanTypeServices } from '../../Settings/Subscription/UrbanType/UrbanTypeServices';
import { ProviderServices } from '../CrudServices';

const SubscriptionInfo = (props) => {
    // const {categoryList,} = props;
    const { control, handleSubmit, setValue, formState: { errors }, watch } = useFormContext();
    const [urbanTypeList, setUrbanTypeList] = useState([]);
    const fetchUrbanTypeList = async() => {
        try{
            const response = await UrbanTypeServices.fetchValidUrbanTypeList();
            console.log('urban type list fetching response :',response);

            if(response.success == '1'){
                setUrbanTypeList(response.data)
            }else if (response.success == '0'){
                console.log("error :",response?.message)
            }
        }catch (error){
            console.log("error:",error)
        }
    }
    const [categoryList, setCategoryList] = useState([]);
    useEffect(() => {   
        fetchUrbanTypeList();
    }, []);
    const subscriptionUrbanTypeId = watch('subscriptionUrbanTypeId');
    useEffect(() => {
        setValue('subscriptionCategoryId', '');
        const fetchCategoryList = async() => {
            try{
                if(subscriptionUrbanTypeId){
                    const response = await ProviderServices.fetchCategoryListByUrbanTypeId(subscriptionUrbanTypeId);
                    console.log('category list by urban type id response :',response);
    
                    if(response.success == '1'){
                        setCategoryList(response.data)
                    }else if (response.success == '0'){
                        console.log("error :",response?.message)
                        setCategoryList([])
                    }
                }else{
                    setCategoryList([])
                }
            }catch (error){
                console.log("error:",error)
            }
        }
        fetchCategoryList();
    }, [subscriptionUrbanTypeId]);
  return (
    <Grid item xs={12}>
        <Card sx={{}}>
            <Box sx={{ p: '.5%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
                <Typography sx={{ fontWeight: '600', fontSize: '.85rem' }}>Subscription Info</Typography>
            </Box>
            <Grid container spacing={2} sx={{ p: '1%' }}>
                <Grid item xs={12} sm={6} md={4} lg={3} >
                    <Typography sx={{fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Subscription Plan <Box component={'span'} style={{ color: '#d32f2f' }}>*</Box></Typography>
                    <Controller
                        name='subscriptionUrbanTypeId'
                        control={control}
                        rules={{
                            required: 'please select one urban type'
                        }}
                        render={({field,fieldState:{error}})=>
                            // <FormControl sx={{ minWidth: "100%" }} size="small">                                            
                            //     <Select
                            //         {...field}
                            //         value={field.value || ''}
                            //         error={!!error}
                            //         sx={{
                            //             fontSize:'0.65rem',
                            //         }}
                            //     >    
                            //     {
                            //         urbanTypeList && urbanTypeList.length> 0 && urbanTypeList.map(urban=>(
                            //             <MenuItem key={urban.id} value={urban.id} sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>{urban.typeTitle}</MenuItem>
                            //         ))
                            //     }                                
                            //     </Select>
                            // </FormControl>
                            <Autocomplete
                                fullWidth
                                options={urbanTypeList}
                                getOptionLabel={(option) => option?.typeTitle || ''}
                                isOptionEqualToValue={(option, value) =>
                                    option.id === value?.id || option.id === value
                                }
                                value={urbanTypeList.find(urban => urban.id === field.value) || null}
                                onChange={(event, newValue) => {
                                    let finalValue = newValue?.id || null;
                                    field.onChange(finalValue);
                                }}
                                disableClearable
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        // label="Select SAC Code*"
                                        placeholder='Search and Select Urban Type'
                                        error={!!error}
                                        // helperText={error ? error.message : ''}
                                        size="small"
                                        inputProps={{
                                            ...params.inputProps,
                                            style: { fontSize: '0.75rem' }
                                        }}
                                    />
                                )}
                                renderOption={(props, option) => (
                                    <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                        {option.typeTitle || ''}
                                    </MenuItem>
                                )}
                            />
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} >
                    <Typography sx={{fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem'}}>Subscription Category <Box component={'span'} style={{ color: '#d32f2f' }}>*</Box></Typography>
                    <Box sx={{display:'flex',alignItems:'center',gap:1,flexGrow:1,flexDirection:{xs:'column',sm:'row'}}}>
                        <Controller
                            name='subscriptionCategoryId'
                            control={control}
                            rules={{ 
                                required: 'select category' 
                            }}
                            render={({ field, fieldState: { error } }) => (
                                <Autocomplete
                                    disabled={!subscriptionUrbanTypeId || categoryList.length === 0}
                                    fullWidth
                                    options={categoryList}
                                    getOptionLabel={(option) => option?.title || ''}
                                    isOptionEqualToValue={(option, value) =>
                                        option.id === value?.id || option.id === value
                                    }
                                    value={categoryList.find(cat => cat.id === field.value) || null}
                                    onChange={(event, newValue) => {
                                        let finalValue = newValue?.id || null;
                                        field.onChange(finalValue);
                                    }}
                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            // label="Select SAC Code*"
                                            placeholder='Search and Select Category'
                                            error={!!error}
                                            // helperText={error ? error.message : ''}
                                            size="small"
                                            inputProps={{
                                                ...params.inputProps,
                                                style: { fontSize: '0.75rem' }
                                            }}
                                        />
                                    )}
                                    renderOption={(props, option) => (
                                        <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                            {option.title || ''}
                                        </MenuItem>
                                    )}
                                />
                            )}
                        />
                        {/* {loadingCategoryList && <CircularProgress />} */}
                    </Box>
                </Grid>
            </Grid>
        </Card>
    </Grid>
  )
}

export default SubscriptionInfo
